import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CheckCircle2 } from 'lucide-react';
import api from '@/services/apiClient';
import Button from '@/components/ui/Button';
import Input from '@/components/ui/Input';
import styles from '../public.module.css';

/** Aluno convidado pelo personal define a senha e segue para o app. */
export default function AcceptInvite() {
  const [params] = useSearchParams();
  const { t } = useTranslation();
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [done, setDone] = useState(null);
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return setErr(t('invitePage.passwordShort'));
    if (password !== confirm) return setErr(t('invitePage.passwordMismatch'));
    setSaving(true);
    setErr(null);
    try {
      const res = await api.post('/auth/accept-invite', { token, password });
      setDone((res.data || res).email || true);
    } catch (e2) {
      setErr(e2.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.brand}>move<span>z</span></div>
        {done ? (
          <div className={styles.status}>
            <CheckCircle2 size={44} color="var(--volt)" strokeWidth={2} />
            <div className={styles.statusTitle}>{t('invitePage.doneTitle')}</div>
            <p className={styles.hint}>{t('invitePage.doneDesc', { email: typeof done === 'string' ? done : '' })}</p>
          </div>
        ) : (
          <form onSubmit={submit} style={{ display: 'grid', gap: 14, marginTop: 12 }}>
            <div className={styles.statusTitle}>{t('invitePage.title')}</div>
            <p className={styles.hint}>{t('invitePage.subtitle')}</p>
            {!token && <span className={styles.err}>{t('invitePage.missingToken')}</span>}
            <Input label={t('invitePage.password')} type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
            <Input label={t('invitePage.confirm')} type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
            {err && <span className={styles.err}>{err}</span>}
            <Button type="submit" loading={saving} disabled={!token}>{t('invitePage.cta')}</Button>
          </form>
        )}
      </div>
    </div>
  );
}
